/**
 * Queue health alerts (FR-3.1). Opened and resolved by the backend evaluator only: there is
 * no write path, so every alert the UI sees is read-only.
 */

/** The evaluator inputs recorded on the alert, so a manager can see what drove it. */
export type QueueDelayAlertPayload = {
    /** Overdue PENDING/QUEUED cadence follow-ups at evaluation time. */
    pendingOverdue: number;
    /** Calls per hour the workflow's online agents are projected to clear. */
    capacityPerHour: number;
    /** Hours left until the workflow's business day end; 0 once the day has closed. */
    timeRemainingHours: number;
    /** Share (0-100) of pendingOverdue the rest of the day is not projected to clear. */
    atRiskPct: number;
    /** Threshold in force when the alert fired, not the workflow's current setting. */
    thresholdPct: number;
};

export type QueueAlert = {
    id: string;
    workflowId: string;
    alertType: string;
    triggeredAt: string;
    /** Set once the evaluator closes the alert. Absent while it is still firing. */
    resolvedAt?: string | null;
    lastNotifiedAt?: string | null;
    payload: QueueDelayAlertPayload;
};

/**
 * True while an alert is still firing. The list endpoint defaults to open alerts only and the
 * Live Monitor poll drops the field once it closes, but a resolved row must never reach a
 * surface either way: it is stale campaign health, and the evaluator resolves alerts on its
 * own schedule, so a poll in flight can still carry one.
 */
export const isQueueAlertOpen = (alert?: QueueAlert | null): boolean => Boolean(alert && !alert.resolvedAt);
